/* pp-sbs.js
   SIDE BY SIDE (Sept 2026, opened to every product Oct 1 2026). A shopper
   selects up to three pieces, from anywhere on the site, and we photograph
   and film them together. With one or two chosen they can ask the specialist
   to add a piece of their own choosing ("specialist's pick"), and every
   request says what they are deciding between (DECIDING).

   What this file does:
     - keeps the selection in localStorage (pp_sbs_v1) so it follows the
       shopper across pages and tabs, with an in-memory fallback when
       storage is blocked
     - syncs every [data-ppsbs-check] checkbox on the page
     - draws the tray at the bottom of the screen. On a product page not
       yet selected, its first empty slot is Add this.
       On pages where nothing can be added it shrinks to a pill.
     - draws the three slots on a product page ([data-ppsbs-pdp])
     - adds the one-line explainer above a collection grid
     - checks each selected piece is still for sale (/products/x.js) and
       marks it Sold if not, so nobody requests a piece that is gone
     - opens the request drawer (name, email and a required note, as on the
       single request since Sept 30 2026) and, when live, posts to the photo request
       Worker. While ppSbsConfig.live is false it sends NOTHING.

   ONE PHOTO REQUEST (Oct 7 2026). The tray is the customer's photo request,
   not a second service. One piece in it is a complete request (sent as a
   normal single request), two or three make a comparison, and the
   specialist's suggestion is optional.
   Every send carries a one-time id so a double-click makes one request.

   ONE SELECTION, ONE FORM (Oct 7 2026, second pass). There is no separate
   single-piece request any more. Both product page buttons (under Add to
   cart, and in the request section further down) work on the same
   selection: with nothing selected they add this piece and open the form,
   with other pieces selected they add this piece, and once it is in they
   offer Review. The old contact form in the request section stays in the
   page only as a fallback: this script hides it and draws the shared
   buttons in its place, so if the script ever fails the old form still works.

   THE CONFIGURATION IS SAVED. A piece added from its product page is saved
   in the variant chosen there (length, metal, clasp). If the customer later
   changes an option on that page on purpose (a click on the picker), the
   saved piece follows. Coming back to the page never overwrites it with the
   page's default. Pieces added from a collection card start in their first
   available variant, which the form says. The form shows each piece's
   configuration, and what is sent is exactly that variant.

   Typed details are kept in this browser (localStorage, every tab, 7 days),
   through closing the form, failed sends and page changes, and cleared only
   after a confirmed send or Clear.

   TRAY AND PANEL ARE TWO VIEWS OF ONE REQUEST (Oct 7 2026, third pass).
   Browsing shows the compact tray (the chosen pieces, the count, Review
   photo request). Reviewing shows the panel, and the tray is hidden while it
   is open. The panel says how many pieces are selected and offers "Add
   another piece to compare", which only closes the panel: nothing is sent,
   nothing is checked, and everything typed is kept. Review opens, Send
   photo request submits. */
(function () {
  'use strict';
  if (window.ppSbsLoaded) return;
  window.ppSbsLoaded = true;

  var CFG = window.ppSbsConfig || {};
  var MAX = CFG.max || 3;
  var KEY = 'pp_sbs_v1';
  var BACK = 'pp_sbs_back';
  var TTL = 30 * 24 * 3600 * 1000;
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var WORDS = ['', 'one', 'two', 'three'];
  var DECIDING = ['Color', 'Size', 'Quality', 'Price', 'Style', 'Not sure'];

  var mem = [];
  var items = [];
  var soldMap = {};
  var shownAt = Date.now();
  var touchedAt = 0;

  /* ---------- storage ---------- */
  function valid(x) { return x && typeof x.h === 'string' && x.h && x.v; }
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var o = JSON.parse(raw);
      if (!o || !Array.isArray(o.items)) return [];
      if (o.t && Date.now() - o.t > TTL) return [];
      touchedAt = o.t || 0;
      return o.items.filter(valid).slice(0, MAX);
    } catch (e) { return mem.slice(); }
  }
  function save() {
    mem = items.slice();
    touchedAt = Date.now();
    try { window.localStorage.setItem(KEY, JSON.stringify({ v: 1, t: Date.now(), items: items })); } catch (e) {}
  }
  function getBack() { try { return window.localStorage.getItem(BACK) || ''; } catch (e) { return ''; } }
  function setBack(u) { try { window.localStorage.setItem(BACK, u); } catch (e) {} }
  // What they typed in the request form. Kept with the selection, in every
  // tab of this browser (a piece opened in a new tab is common), for 7 days,
  // until the request is sent or they press Clear (Oct 7 2026: it was per tab).
  var DRAFT = 'pp_sbs_draft';
  var DRAFT_TTL = 7 * 24 * 3600 * 1000;
  var memDraft = {};
  function getDraft() {
    try {
      var raw = window.localStorage.getItem(DRAFT);
      if (!raw) { try { raw = window.sessionStorage.getItem(DRAFT); } catch (e2) {} }
      var d = JSON.parse(raw || '{}') || {};
      if (d.at && Date.now() - d.at > DRAFT_TTL) return {};
      return d;
    } catch (e) { return memDraft; }
  }
  function setDraft(d) {
    d.at = Date.now(); memDraft = d;
    try { window.localStorage.setItem(DRAFT, JSON.stringify(d)); } catch (e) {}
  }
  function clearDraft() {
    memDraft = {};
    try { window.localStorage.removeItem(DRAFT); } catch (e) {}
    try { window.sessionStorage.removeItem(DRAFT); } catch (e) {}
  }
  // Whatever is in the form now, however it got there (typing, autofill, a
  // password manager): kept when the panel closes or the page is left.
  function keepForm() {
    if (!dlg || dlg._sent) return;
    var form = dlg.querySelector('.ppsbs-dlg__body form');
    if (!form) return;
    var d = getDraft();
    d.name = form.elements['name'].value; d.email = form.elements['email'].value; d.note = form.elements['note'].value;
    var dc = form.querySelector('input[name="deciding"]:checked');
    d.deciding = dc ? dc.value : (dlg._deciding || '');
    d.pick = !!dlg._pick; if (dlg._sid) d.sid = dlg._sid;
    if (d.name || d.email || d.note || d.deciding || d.sid) setDraft(d);
  }
  window.addEventListener('pagehide', keepForm);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') keepForm(); });

  // A signup popup should not land on top of someone building a request:
  // quiet while the panel is open, or for two hours after they last changed
  // their selection. Once quiet, quiet for the rest of that page.
  function quiet() {
    var on = dlgOpen() || (items.length && touchedAt && Date.now() - touchedAt < 2 * 3600 * 1000);
    if (!on || document.documentElement.classList.contains('ppsbs-quiet')) return;
    // Klaviyo's popups and flyouts, and their teasers.
    var st = document.createElement('style');
    st.textContent = 'html.ppsbs-quiet .needsclick[role="dialog"][aria-label$=" Form"],html.ppsbs-quiet .needsclick[class*="kl-teaser"]{display:none !important}';
    document.head.appendChild(st);
    document.documentElement.classList.add('ppsbs-quiet');
  }

  /* ---------- model ---------- */
  function fromEl(el) {
    var o = {
      h: el.getAttribute('data-h'), pid: el.getAttribute('data-pid'), v: el.getAttribute('data-v'),
      t: el.getAttribute('data-t') || '', sku: el.getAttribute('data-sku') || '',
      p: el.getAttribute('data-p') || '', img: el.getAttribute('data-img') || '', u: el.getAttribute('data-u') || '',
      one: el.getAttribute('data-one') === '1',
      vt: el.getAttribute('data-vt') || '', vset: false,
      two: el.getAttribute('data-two') || '', // "two options for this same bracelet": the product page knows, a card does not
      opts: el.getAttribute('data-opts') || '', // "two matched pairs", "two strands": the short form for the drawer row
      same: el.getAttribute('data-same') || '', // "this same bracelet": blank for loose pearls and pairs, which are not made into anything
      made: el.getAttribute('data-made') || '', // "We'll make yours with the exact pearls you choose." (loose pearls: "The exact pearls you choose are yours.")
      twoOn: false // true once they tick Show me two options on its row in the panel
    };
    // A card knows its first available variant: show that price, not "From".
    if (el.getAttribute('data-vp')) o.p = el.getAttribute('data-vp');
    return o;
  }
  // The product page piece, in the variant selected on the page right now.
  function pdpVariants(root) {
    if (root._vars) return root._vars;
    var el = root.querySelector('[data-ppsbs-variants]'), list = [];
    try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
    root._vars = list;
    return list;
  }
  function findVar(root, id) {
    var l = pdpVariants(root);
    for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(id)) return l[i];
    return null;
  }
  function pageVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest && forms[i].closest('[data-ppd-req]')) continue;
      var id = forms[i].querySelector('[name="id"]');
      if (id && id.value) return String(id.value);
    }
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }
  function withVariant(it, v) {
    if (!v) return it;
    it.v = String(v.id); it.vt = v.title || ''; if (v.sku) it.sku = v.sku; if (v.price) it.p = v.price;
    return it;
  }
  function pdpItem() {
    var root = pdpRoot();
    var it = withVariant(fromEl(root), findVar(root, pageVariantId()));
    it.vset = true;
    sizeSetup(it, root);
    return it;
  }
  /* THE SIZE TO PHOTOGRAPH (Oct 19 2026, PR-1176). Loose pearls: the size
     the page loaded with was being sent without anyone choosing it. The
     request section marks which option is the size (data-ppd-size-oi). The
     piece's row in the panel asks for it, starting from "Choose a size", and
     the request can't go until it is chosen. The piece's variants travel
     with it, so the panel works on any page. */
  function sizeSetup(it, root) {
    var sec = document.querySelector('[data-ppd-req][data-ppd-size-oi]');
    var oi = sec ? parseInt(sec.getAttribute('data-ppd-size-oi'), 10) : -1;
    if (!(oi >= 0)) return;
    // Options and stock from the request section's own list; the price as
    // the panel shows it, from this block's list.
    var full = [];
    try { var fe = sec.querySelector('[data-ppd-size-variants]'); full = fe ? JSON.parse(fe.textContent) : []; } catch (e) { full = []; }
    var vars = full.map(function (v) { var mine = findVar(root, v.id) || {}; return { id: String(v.id), o: v.options || [], a: !!v.available, t: v.title || '', s: v.sku || mine.sku || '', p: mine.price || '' }; });
    var seen = {};
    vars.forEach(function (v) { if (v.o[oi] != null) seen[v.o[oi]] = 1; });
    if (Object.keys(seen).length < 2) return;
    it.soi = oi; it.svars = vars; it.sizeOk = false;
  }
  function sizeOf(it) {
    if (it.soi == null || !it.svars) return '';
    for (var i = 0; i < it.svars.length; i++) if (it.svars[i].id === String(it.v)) return it.svars[i].o[it.soi];
    return '';
  }
  function needsSize(it) { return it && it.soi != null && it.svars && !it.sizeOk; }
  function sizeHtml(it) {
    if (it.soi == null || !it.svars) return '';
    var sizes = [], stock = {};
    it.svars.forEach(function (v) { var z = v.o[it.soi]; if (z == null) return; if (sizes.indexOf(z) === -1) sizes.push(z); if (v.a) stock[z] = 1; });
    var cur = it.sizeOk ? sizeOf(it) : '';
    var h = '<label class="ppsbs-size' + (it.sizeOk ? '' : ' is-need') + '" style="display:block;margin:8px 0 0"><span style="display:block;font-size:12px;letter-spacing:.06em;text-transform:uppercase;margin:0 0 4px">Size to photograph</span>' +
      '<select data-ppsbs-size="' + esc(it.h) + '" style="width:100%;max-width:320px;padding:8px 10px;font-size:15px"><option value="">Choose a size</option>';
    sizes.forEach(function (z, k) {
      h += '<option value="' + k + '"' + (z === cur ? ' selected' : '') + (stock[z] ? '' : ' disabled') + '>' + esc(String(z).replace(/(\d)\s*mm\b/g, '$1 mm')) + (stock[z] ? '' : ' (sold out)') + '</option>';
    });
    return h + '</select></label>';
  }
  function pickSize(it, k) {
    var sizes = [];
    it.svars.forEach(function (v) { var z = v.o[it.soi]; if (z != null && sizes.indexOf(z) === -1) sizes.push(z); });
    var z = sizes[k];
    if (z == null) return;
    var base = null, i;
    for (i = 0; i < it.svars.length; i++) if (it.svars[i].id === String(it.v)) base = it.svars[i];
    var hit = null;
    if (base) {
      var want = base.o.slice(); want[it.soi] = z;
      for (i = 0; i < it.svars.length && !hit; i++) if (it.svars[i].o.join('|') === want.join('|')) hit = it.svars[i];
    }
    for (i = 0; i < it.svars.length && !hit; i++) if (it.svars[i].o[it.soi] === z && it.svars[i].a) hit = it.svars[i];
    for (i = 0; i < it.svars.length && !hit; i++) if (it.svars[i].o[it.soi] === z) hit = it.svars[i];
    if (!hit) return;
    withVariant(it, { id: hit.id, title: hit.t, sku: hit.s, price: hit.p });
    it.sizeOk = true;
  }
  // "14K White Gold Fishhook / 18 inch" -> "14K White Gold Fishhook · 18 inch"
  function cfgText(it) {
    var t = String((it && it.vt) || '');
    if (!t || /^default title$/i.test(t)) return '';
    return t.split(' / ').join(' · ').replace(/(\d)mm\b/g, '$1 mm');
  }
  function idx(h) { for (var i = 0; i < items.length; i++) if (items[i].h === h) return i; return -1; }
  function has(h) { return idx(h) !== -1; }
  function add(it, front) {
    if (has(it.h)) return 'dup';
    if (items.length >= MAX) return 'full';
    if (front) items.unshift(it); else items.push(it);
    save(); return 'ok';
  }
  function remove(h) { var i = idx(h); if (i !== -1) { items.splice(i, 1); save(); } }
  function clearAll() { items = []; save(); }
  function isSold(h) { return soldMap[h] === true; }
  function live() { return items.filter(function (x) { return !isSold(x.h); }); }

  /* ---------- helpers ---------- */
  function newSid() {
    try { var a = new Uint8Array(12); window.crypto.getRandomValues(a); return 'sb' + Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
    catch (e) { return 'sb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  }
  function pieces(n) { return n === 1 ? '1 product' : n + ' products'; }
  /* A stocked piece is photographed as one unless they tick two options for
     it (same spec, same price, side by side). Two or three pieces are
     photographed together as chosen. One of a kind is shown up close. */
  // "two options for this same bracelet"; a piece added from a card has no
  // form on it, so it falls back to a plain phrase.
  function twoOf(it) { return (it && !it.one && it.two) || (it && !it.one ? 'two options for this same piece' : ''); }
  function madeOf(it) { return (it && it.made) || "We'll make yours with the exact pearls you choose."; }
  /* TWO PER PIECE (Oct 11 2026). The promise is per piece and travels with
     it: ticked on its row, two to choose from, and adding other pieces never
     takes that away. One of a kind: that exact piece. */
  function wantsTwo(it) { return !!(it && !it.one && it.twoOn); }
  function optsOf(it) { return (it && it.opts) || 'two options'; }
  function twos(list) { return list.filter(wantsTwo).length; }
  /* EASY ASK, TWO OPTIONAL (Oct 12 2026). The product page asks the simple
     question again (see the pearls we'd use). Two options is a checkbox on
     the piece's row in the panel, off until they tick it. */
  function rowLine(it, n) {
    if (it.one) return '<p class="ppsbs-dlg__plan">This exact piece, photographed for you.</p>';
    var on = wantsTwo(it);
    var o = optsOf(it);
    return '<p class="ppsbs-dlg__plan">' + (on ? '<b>' + esc(o.charAt(0).toUpperCase() + o.slice(1)) + ' to choose from.</b> ' + esc(madeOf(it)) : (n > 1 ? 'One, to compare with the others.' : esc(oneLine(it)))) + '</p>' +
      '<label class="ppsbs-opt' + (on ? ' is-on' : '') + '"><input type="checkbox" data-ppsbs-two="' + esc(it.h) + '"' + (on ? ' checked' : '') + '>' +
      '<span><b>Show me ' + esc(introTwo(it)) + '.</b> See them side by side and choose the one you prefer.</span></label>';
  }
  // "two strands for this same necklace"; loose pearls and pairs have no piece to
  // make, so their phrase is "two sets of pearls at this size and quality".
  // Necklaces, pendants and rings name the thing ("two strands for this same
  // necklace"); a bracelet or set reads "two options for this same bracelet".
  function introTwo(it) { return it.same && it.opts && it.opts !== 'two sets of pearls' ? it.opts + ' for ' + it.same : (it.two || 'two options for this same piece'); }
  // "The actual strand we'd use, photographed for you." A pair or loose
  // pearls are the thing itself: "The exact pair you'd receive."
  function oneLine(it) {
    var o = optsOf(it);
    var thing = o === 'two strands' ? 'strand' : (/pair/.test(o) ? 'pair' : (/^two pearls\b/.test(o) ? 'pearl' : 'pearls'));
    if (/^The exact/.test(it.made || '')) return 'The exact ' + thing + " you'd receive, photographed for you.";
    return 'The actual ' + thing + " we'd use, photographed for you.";
  }
  function singleTwo(list) { return list.length === 1 && wantsTwo(list[0]); }
  function planLine(list) {
    var n = list.length;
    if (!n) return '';
    if (n === 1 && list[0].one) return "We'll send fresh photos and a video of this exact piece.";
    if (n === 1) return "We'll send you photos and a video of the actual pearls we'd use for this piece.";
    var k = twos(list);
    return "We'll photograph these " + (WORDS[n] || n) + ' pieces together so you can compare them' + (k ? ', with two options to choose from for ' + (k === 1 ? 'one of them.' : k + ' of them.') : '.');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function pdpRoot() { return document.querySelector('[data-ppsbs-pdp]'); }
  function hint(msg, warn) {
    var hEl = tray && tray.querySelector('.ppsbs-tray__hint');
    if (!hEl) return;
    hEl.textContent = msg;
    hEl.classList.toggle('is-warn', !!warn);
    if (warn) {
      tray.classList.remove('is-nudge'); void tray.offsetWidth; tray.classList.add('is-nudge');
      clearTimeout(hint._t);
      hint._t = setTimeout(renderTray, 3800);
    }
  }
  var FULL_MSG = "You've chosen three. Remove one to add another.";

  /* ---------- checkboxes ---------- */
  function syncChecks() {
    var full = items.length >= MAX;
    var list = document.querySelectorAll('[data-ppsbs-check]');
    for (var i = 0; i < list.length; i++) {
      var lab = list[i], box = lab.querySelector('input');
      var on = has(lab.getAttribute('data-h'));
      if (box) { box.checked = on; box.setAttribute('aria-disabled', (!on && full) ? 'true' : 'false'); }
      lab.classList.toggle('is-on', on);
      lab.classList.toggle('is-locked', !on && full);
      lab.title = (!on && full) ? FULL_MSG : '';
    }
  }
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.classList || !box.classList.contains('ppsbs-check__box')) return;
    var lab = box.closest('[data-ppsbs-check]');
    if (!lab) return;
    if (box.checked) {
      // Ticked in the strip under a product: the note there promises the
      // piece is photographed next to this one, so this one goes in first.
      var pdp = pdpRoot();
      if (pdp && lab.closest('#ppsbs-more') && !has(pdp.getAttribute('data-h')) && items.length < MAX - 1) {
        add(pdpItem(), true);
        pdp._folded = false;
      }
      var r = add(fromEl(lab));
      if (r === 'full') { box.checked = false; render(); hint(FULL_MSG, true); return; }
    } else {
      remove(lab.getAttribute('data-h'));
    }
    render();
    checkSold();
  });

  /* ---------- explainer ---------- */
  function explainer() {
    var t = CFG.pageType;
    if (t !== 'collection' && t !== 'search') return;
    var first = document.querySelector('[data-ppsbs-check]');
    if (!first || document.querySelector('.ppsbs-explain')) return;
    setBack(location.pathname + location.search);
    var grid = first.closest('.ppc__grid') || first.closest('.grid');
    if (!grid || !grid.parentNode) return;
        // Only where nearly every card can be added (sold-out cards have no checkbox). Elsewhere the checkboxes stand on their own.
    if (grid.querySelectorAll('[data-ppsbs-check]').length < grid.children.length * 0.8) return;
    var box = el('div', 'ppsbs-explain',
      "<p><b>Deciding between pieces?</b> Add up to three to a photo request, from anywhere on the site, " +
      "and we'll photograph and film the actual pieces together." +
      '<button type="button" class="ppsbs-link" data-ppsbs-how>How it works</button></p>');
    grid.parentNode.insertBefore(box, grid);
  }

  /* ---------- where "+ add" goes ---------- */
  function goFind() {
    var strip = document.getElementById('ppsbs-more');
    var first = document.querySelector('[data-ppsbs-check]');
    var target = strip || (first && (first.closest('.ppc__grid') || first.closest('.grid')));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var pdp = pdpRoot();
    var dest = getBack() || (pdp && pdp.getAttribute('data-browse')) || '';
    if (dest) window.location.href = dest;
  }

  /* ---------- tray ---------- */
  var tray = null;
  function buildTray() {
    tray = el('div', 'ppsbs-tray');
    tray.setAttribute('role', 'region');
    tray.setAttribute('aria-label', 'Your photo request');
    tray.innerHTML =
      '<div class="ppsbs-tray__in">' +
        '<div class="ppsbs-tray__slots"></div>' +
        '<div class="ppsbs-tray__meta">' +
          '<p class="ppsbs-tray__count" aria-live="polite"></p>' +
          '<p class="ppsbs-tray__hint"></p>' +
          '<button type="button" class="ppsbs-tray__clear" data-ppsbs-clear>Clear</button>' +
        '</div>' +
        '<button type="button" class="ppsbs-btn" data-ppsbs-open>Review photo request</button>' +
      '</div>';
    document.body.appendChild(tray);
  }
  function slotHtml(it) {
    var sold = isSold(it.h);
    return '<div class="ppsbs-slot' + (sold ? ' is-sold' : '') + '">' +
      '<a href="' + esc(it.u) + '" title="' + esc(it.t) + '"><img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" loading="lazy"></a>' +
      (sold ? '<span class="ppsbs-sold">Sold</span>' : '') +
      '<button type="button" class="ppsbs-slot__x" data-ppsbs-rm="' + esc(it.h) + '" aria-label="Remove ' + esc(it.t) + '">&times;</button>' +
      '</div>';
  }
  function dlgOpen() { return !!(dlg && !dlg.hidden); }
  function renderTray() {
    if (!tray) buildTray();
    quiet();
    var n = items.length;
    // The chosen pieces, and on a product page whose piece is not in yet,
    // that piece faded in the next spot with Add this (in the options
    // selected on the page). No empty slots: adding more is offered on
    // product pages, on collection cards and inside the panel.
    var pdp = pdpRoot();
    var here = pdp && !has(pdp.getAttribute('data-h')) && n < MAX ? pdpItem() : null;
    var slots = '';
    for (var i = 0; i < n; i++) slots += slotHtml(items[i]);
    if (here) {
      slots += '<button type="button" class="ppsbs-slot ppsbs-slot--here" data-ppsbs-addhere aria-label="Add ' + esc(here.t) + ' to your photo request">' +
        (here.img ? '<img src="' + esc(here.img) + '" alt="">' : '') + '<span><i>+</i>Add this</span></button>';
    }
    tray.querySelector('.ppsbs-tray__slots').innerHTML = slots;
    tray.querySelector('.ppsbs-tray__count').textContent = 'Your photo request · ' + pieces(n);
    var ok = live().length;
    var soldN = n - ok;
    var msg;
    if (soldN) msg = (soldN === 1 ? 'One piece has' : 'Some pieces have') + ' sold. Remove it to choose another.';
    else if (here) msg = 'Tap Add this to include the piece you are viewing.';
    else if (ok < 2) msg = 'Add up to two more pieces to compare, or review and send.';
    else if (ok < MAX) msg = 'You can add one more piece to compare.';
    else msg = 'Three pieces selected.';
    var hEl = tray.querySelector('.ppsbs-tray__hint');
    hEl.textContent = msg; hEl.classList.toggle('is-warn', !!soldN);
    var tb = tray.querySelector('[data-ppsbs-open]');
    tb.disabled = n < 1;
    tb.textContent = 'Review photo request';
    // Pages where nothing can be added (a stocked pendant, the cart, a blog
    // post) get the small pill instead of the full tray. See renderPill.
    // Neither shows while the panel is open: the panel is the same request.
    var full = eligiblePage();
    var show = n > 0 && full && !dlgOpen();
    tray.classList.toggle('is-on', show);
    document.body.classList.toggle('ppsbs-has-tray', show);
    renderPill(n > 0 && !full && !dlgOpen());
  }

  /* ---------- pill (Sept 30 2026) ----------
     On a page where nothing can be added (the cart, a blog post, a sold-out
     piece), the full tray with its empty + slots promised something the page
     could not do. The pill keeps the selection in view, opens to show it, and
     points back to where more can be chosen.

     A page can add when it is a product page still for sale (it has the
     side by side rows), or a collection or search page with at least one
     See side by side checkbox. Since Oct 1 2026 that is any product, not only
     one-of-a-kind pieces. */
  function eligiblePage() {
    if (pdpRoot()) return true;
    var t = CFG.pageType;
    return (t === 'collection' || t === 'search') && !!document.querySelector('[data-ppsbs-check]');
  }
  var pill = null;
  function buildPill() {
    pill = el('div', 'ppsbs-pill');
    pill.hidden = true;
    pill.innerHTML =
      '<div class="ppsbs-pill__pop" id="ppsbs-pill-pop" hidden>' +
        '<div class="ppsbs-pill__head"><b>Your photo request</b>' +
          '<button type="button" class="ppsbs-pill__x" data-ppsbs-pill-close aria-label="Close">&times;</button></div>' +
        '<div class="ppsbs-pill__slots"></div>' +
        '<p class="ppsbs-pill__note">Add pieces from anywhere on the site. We photograph and film the actual pieces together.</p>' +
        '<div class="ppsbs-pill__acts">' +
          '<button type="button" class="ppsbs-btn" data-ppsbs-open>Review photo request</button>' +
          '<div class="ppsbs-pill__more"><span>Keep browsing</span>' +
            '<a class="ppsbs-pill__browse" href="/collections/akoya-pearls">akoya</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/tahitian-pearls">Tahitian</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/south-sea-pearls">South Sea</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/freshwater-pearls">Freshwater</a>' +
            '<a class="ppsbs-pill__browse" href="/collections/the-vault-collection">The Vault</a></div>' +
          '<button type="button" class="ppsbs-tray__clear" data-ppsbs-clear>Clear</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="ppsbs-pill__btn" data-ppsbs-pill aria-expanded="false" aria-controls="ppsbs-pill-pop">' +
        '<span class="ppsbs-pill__pics"></span><span class="ppsbs-pill__txt"></span><i aria-hidden="true"></i>' +
      '</button>';
    document.body.appendChild(pill);
  }
  function renderPill(show) {
    if (!show) { if (pill) { pill.hidden = true; pillOpen(false); } return; }
    if (!pill) buildPill();
    var n = items.length, ok = live().length, pics = '', slots = '';
    for (var i = 0; i < n; i++) {
      var it = items[i];
      pics += '<img src="' + esc(it.img) + '" alt=""' + (isSold(it.h) ? ' class="is-sold"' : '') + '>';
      slots += slotHtml(it);
    }
    pill.querySelector('.ppsbs-pill__pics').innerHTML = pics;
    pill.querySelector('.ppsbs-pill__txt').textContent = 'Your photo request · ' + pieces(n);
    pill.querySelector('.ppsbs-pill__slots').innerHTML = slots;
    var go = pill.querySelector('[data-ppsbs-open]');
    go.disabled = n < 1;
    go.textContent = 'Review photo request';
    pill.hidden = false;
  }
  function pillOpen(open) {
    if (!pill) return;
    var pop = pill.querySelector('.ppsbs-pill__pop');
    pop.hidden = !open;
    pill.querySelector('[data-ppsbs-pill]').setAttribute('aria-expanded', open ? 'true' : 'false');
    pill.classList.toggle('is-open', open);
  }
  document.addEventListener('click', function (e) {
    if (!pill || pill.hidden) return;
    var t = e.target;
    if (t.closest && t.closest('[data-ppsbs-pill]')) {
      pillOpen(pill.querySelector('.ppsbs-pill__pop').hidden); return;
    }
    if (t.closest && t.closest('[data-ppsbs-pill-close]')) { pillOpen(false); return; }
    if (t.closest && t.closest('[data-ppsbs-open]')) { pillOpen(false); return; }
    // A remove button inside the pill is re-rendered before this runs, so
    // its target is detached by now. That is not an outside click.
    if (!document.documentElement.contains(t)) return;
    if (!pill.contains(t)) pillOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pill && !pill.hidden) pillOpen(false);
  });

  /* ---------- product page buttons (Oct 7 2026) ----------
     The block under Add to cart and the request section further down say
     the same thing and do the same thing. Four states:
       nothing selected        Request photos & video: add this piece, open the form
       others, not this one    Add this piece (nothing is sent yet)
       this one is in          Review photo request, with its saved options
       three others            Review photo request; remove one to add this
     The secondary line under the top block adds without opening, for
     someone who wants to keep browsing and compare. */
  function pdpState() {
    var root = pdpRoot();
    var me = root.getAttribute('data-h');
    var noun = root.getAttribute('data-noun') || 'piece';
    var n = items.length, i = idx(me);
    if (!n) return { k: 'empty', noun: noun, n: 0 };
    if (i !== -1) return { k: 'mine', noun: noun, n: n, it: items[i], others: n - 1 };
    if (n < MAX) return { k: 'add', noun: noun, n: n };
    return { k: 'full', noun: noun, n: n };
  }
  function savedLine(st) {
    var c = cfgText(st.it);
    var root = pdpRoot();
    var upd = root._updated && Date.now() - root._updated < 8000;
    if (needsSize(st.it)) return 'Choose the size to photograph in your request.';
    return c ? (upd ? 'Updated to ' : 'Saved as ') + esc(c) + '.' : '';
  }
  function pdpCopy(st) {
    var noun = esc(st.noun);
    if (st.k === 'empty') return {
      say: '', sub: '',
      btn: 'Request photos &amp; video', attr: 'data-ppsbs-pdp-request'
    };
    if (st.k === 'mine') return {
      say: 'This ' + noun + ' is in your photo request',
      sub: [savedLine(st), st.others ? 'Along with ' + (st.others === 1 ? '1 other piece' : st.others + ' other pieces') + '.' : '', planLine(live())].filter(Boolean).join(' '),
      btn: 'Review photo request', attr: 'data-ppsbs-open'
    };
    if (st.k === 'add') return {
      say: 'You have ' + pieces(st.n) + ' in your photo request',
      sub: 'Add this ' + noun + ' to see ' + (st.n === 1 ? 'the two' : 'all three') + ' together. Nothing is sent until you review it.',
      btn: 'Add this ' + noun, attr: 'data-ppsbs-pdp-open'
    };
    return {
      say: 'Your photo request has three pieces',
      sub: 'Remove one to add this ' + noun + '.',
      btn: 'Review photo request', attr: 'data-ppsbs-open'
    };
  }
  function renderPdp() {
    var root = pdpRoot();
    if (!root) return;
    var main = root.querySelector('[data-ppsbs-pdp-main]');
    var also = root.querySelector('[data-ppsbs-pdp-also]');
    if (!main) return;
    if (!root._orig) root._orig = { main: main.innerHTML };
    var st = pdpState(), c = pdpCopy(st);
    var btn = '<button type="button" class="ppsbs-pdp__act" ' + c.attr + '>' + c.btn + '</button>';
    if (st.k === 'empty') {
      // The Liquid wording stays; only the link becomes the shared button.
      main.innerHTML = root._orig.main;
      var a = main.querySelector('.ppsbs-pdp__act');
      if (a) a.outerHTML = btn;
    } else {
      main.innerHTML = '<p class="ppsbs-pdp__say"><b>' + c.say + '</b>' + (c.sub ? '<span>' + c.sub + '</span>' : '') + '</p>' + btn;
    }
    if (also) also.hidden = st.k !== 'empty';
  }
  // The request section further down the page. Its own form is the fallback
  // and is hidden while this runs; the panel here does what the top block does.
  function renderLower() {
    var root = pdpRoot();
    var sec = document.querySelector('[data-ppd-req]');
    if (!root || !sec) return;
    var form = sec.querySelector('form');
    if (form && form.querySelector('.ppd-sent.is-on')) return; // the fallback form just sent
    var panel = sec.querySelector('.ppsbs-lower');
    if (!panel) {
      var lead = sec.querySelector('.ppd-req__lead');
      var host = (lead && lead.parentNode) || (form && form.parentNode);
      if (!host) return;
      panel = el('div', 'ppsbs-lower');
      if (lead && lead.nextSibling) host.insertBefore(panel, lead.nextSibling); else host.appendChild(panel);
    }
    if (form) { form.hidden = true; form.style.display = 'none'; }
    var st = pdpState(), c = pdpCopy(st);
    var one = root.getAttribute('data-one') === '1';
    panel.innerHTML =
      (st.k === 'empty' ? '' : '<p class="ppsbs-lower__say"><b>' + c.say + '</b>' + (c.sub ? '<span>' + c.sub + '</span>' : '') + '</p>') +
      '<button type="button" class="ppsbs-btn ppsbs-lower__btn" ' + c.attr + '>' + c.btn + '</button>' +
      (st.k === 'empty' ? '<p class="ppsbs-lower__fine">' + esc(holdLine([{ one: one }])) + ' We usually reply within one business day, Monday through Friday.</p>' : '');
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var req = e.target.closest('[data-ppsbs-pdp-request]');
    var addb = e.target.closest('[data-ppsbs-pdp-open]');
    if (!req && !addb) return;
    e.preventDefault();
    var root = pdpRoot();
    if (!root) return;
    var mine = pdpItem();
    // Request photos adds this piece as one; two options is the checkbox on
    // its row in the panel (EASY ASK, TWO OPTIONAL, Oct 12 2026).
    var r = has(root.getAttribute('data-h')) ? 'dup' : add(mine);
    render();
    checkSold();
    if (r === 'full') { hint('Your photo request has three pieces. Remove one to add this ' + (root.getAttribute('data-noun') || 'piece') + '.', true); return; }
    if (req) openDlg('req', req);
  });

  /* A deliberate change of options on the product page (a click on the
     picker, or a change on a select) moves the saved piece to the new
     variant. Nothing else does: arriving on the page, or the page script
     setting its default, never overwrites what was saved. */
  var lastVid = '';
  function checkVariant() {
    var root = pdpRoot();
    if (!root) return;
    var cur = pageVariantId();
    if (!cur || cur === lastVid) return;
    lastVid = cur;
    var i = idx(root.getAttribute('data-h'));
    if (i === -1) return;
    var v = findVar(root, cur);
    if (!v || String(items[i].v) === String(v.id)) return;
    withVariant(items[i], v);
    items[i].vset = true;
    save();
    root._updated = Date.now();
    render();
  }
  function watchVariant() {
    if (!pdpRoot()) return;
    lastVid = pageVariantId();
    var later = function () { setTimeout(checkVariant, 0); setTimeout(checkVariant, 250); };
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ppdh-opt],[data-ppdh-metalfilter],form[action*="/cart/add"]')) later();
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-ppdh],form[action*="/cart/add"]') && !e.target.closest('[data-ppd-req]')) later();
    });
  }

  /* ---------- drawer ---------- */
  var dlg = null, opener = null;
  function buildDlg() {
    dlg = el('div', 'ppsbs-dlg');
    dlg.hidden = true;
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'ppsbs-dlg-h');
    dlg.innerHTML = '<div class="ppsbs-dlg__scrim" data-ppsbs-close></div>' +
      '<div class="ppsbs-dlg__panel"><button type="button" class="ppsbs-dlg__x" data-ppsbs-close aria-label="Close">&times;</button>' +
      '<div class="ppsbs-dlg__body"></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDlg(); return; }
      if (e.key !== 'Tab') return;
      var f = dlg.querySelectorAll('a[href],button:not([disabled]),input:not(.ppsbs-hp),textarea');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }
  function openDlg(mode, from) {
    if (!dlg) buildDlg();
    opener = from || document.activeElement;
    dlg._mode = mode;
    dlg._sent = false;
    if (mode === 'req') { try { if (window.gtag) window.gtag('event', 'photo_request_open', { piece_count: live().length, two_count: twos(live()) }); } catch (e) {} }
    drawDlg();
    dlg.hidden = false;
    document.documentElement.classList.add('ppsbs-lock');
    renderTray();
    var f = dlg.querySelector(mode === 'how' ? '.ppsbs-dlg__x' : 'input[name="name"]') || dlg.querySelector('.ppsbs-dlg__x');
    setTimeout(function () { try { f.focus(); } catch (e) {} }, 30);
  }
  function closeDlg() {
    if (!dlg || dlg.hidden) return;
    keepForm();
    dlg.hidden = true;
    document.documentElement.classList.remove('ppsbs-lock');
    renderTray();
    if (opener && opener.focus && document.documentElement.contains(opener)) { try { opener.focus(); } catch (e) {} }
  }
  function howHtml() {
    return '<p class="ppsbs-eyebrow">Photo request</p><h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">How it works</h2>' +
      '<ol class="ppsbs-steps">' +
      '<li>Ask about one piece and we photograph the actual pearls we\'d use for it. Or add up to three different pieces from anywhere on the site and we show those together.</li>' +
      '<li>We lay them side by side under the same light, photograph them together and film one comparison video.</li>' +
      '<li>You get a private page with the photos, the video and a buy button for each piece, usually within one business day.</li>' +
      '</ol>' +
      '<p class="ppsbs-fine">' + holdLine(items) + '</p>' +
      '<p style="margin:20px 0 0"><button type="button" class="ppsbs-btn" data-ppsbs-close>Got it</button></p>';
  }
  function reqHtml() {
    var ok = live().length;
    var list = '';
    if (!dlg) buildDlg();
    for (var i = 0; i < items.length; i++) {
      var it = items[i], sold = isSold(it.h);
      list += '<li class="ppsbs-dlg__item' + (sold ? ' is-sold' : '') + '">' +
        '<span class="ppsbs-dlg__pic"><img src="' + esc(it.img) + '" alt="">' + (sold ? '<span class="ppsbs-sold">Sold</span>' : '') + '</span>' +
        '<span class="ppsbs-dlg__txt"><p class="ppsbs-dlg__t"><a href="' + esc(it.u) + '">' + esc(it.t) + '</a></p>' +
        (cfgText(it) ? '<p class="ppsbs-dlg__cfg">' + esc(needsSize(it) ? cfgText(it).split(' · ').filter(function (x, k) { return k !== it.soi; }).join(' · ') : cfgText(it)) + '</p>' : '') +
        (sold ? '' : sizeHtml(it)) +
        (cfgText(it) && !it.vset ? '<p class="ppsbs-dlg__def">Starting options. To choose others, open the piece and change them there.</p>' : '') +
        '<p class="ppsbs-dlg__m">' + (it.sku ? esc(it.sku) + ' · ' : '') + (sold ? 'Sold' : esc(it.p)) + '</p>' +
        (sold ? '' : rowLine(it, items.length)) + '</span>' +
        '<button type="button" class="ppsbs-dlg__rm" data-ppsbs-rm="' + esc(it.h) + '">Remove</button></li>';
    }
    // The specialist's suggestion is for a comparison the customer started
    // themselves (two pieces). With one piece the default already covers it.
    var canPick = ok < MAX && ok >= 2;
    var pickOn = canPick && !!dlg._pick;
    var n = items.length;
    var chips = '';
    for (var di = 0; di < DECIDING.length; di++) {
      chips += '<label class="ppsbs-q__c"><input type="radio" name="deciding" value="' + DECIDING[di] + '"' + (dlg._deciding === DECIDING[di] ? ' checked' : '') + '><span>' + DECIDING[di] + '</span></label>';
    }
    // How many, then the pieces, then the one way to add more. Adding more
    // closes the panel and keeps everything; it never sends or checks.
    var count = n >= MAX ? 'Three products selected. Remove one to choose a different one.' :
      (n === 1 ? '1 product selected' : n + ' products selected');
    var more = n > 0 && n < MAX ?
      '<div class="ppsbs-more"><button type="button" class="ppsbs-more__btn" data-ppsbs-more><span aria-hidden="true">+</span> Add another piece to compare</button>' +
      '<p class="ppsbs-more__note">' + (n === 1 ? 'You can send your request with one piece or add up to two more.' : 'You can add one more piece to compare.') + '</p></div>' : '';
    return '<h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">Your photo request</h2>' +
      '<p class="ppsbs-dlg__lede">' + (live().length > 1 ? "We'll photograph and film your selection together, with your specialist explaining the differences. What we show for each piece is under it below." : (planLine(live()) || "We'll send you photos and a video of the actual pearls.")) + '</p>' +
      '<p class="ppsbs-dlg__lede ppsbs-dlg__when">Photos and video usually sent within one business day.</p>' +
      '<p class="ppsbs-dlg__count">' + count + '</p>' +
      '<ul class="ppsbs-dlg__list">' + list + '</ul>' + more +
      (ok < items.length ? '<p class="ppsbs-err">A piece you selected has sold. Remove it, or send the request for the others.</p>' : '') +
      '<form class="ppsbs-form" novalidate>' +
        '<label class="ppsbs-field"><span>Your name</span><input type="text" name="name" required maxlength="80" autocomplete="name" placeholder="First and last name"></label>' +
        '<label class="ppsbs-field"><span>Your email address</span><input type="email" name="email" required autocomplete="email" placeholder="you@example.com"></label>' +
        '<fieldset class="ppsbs-q"><legend>What matters most to you? <span>(optional)</span></legend><div class="ppsbs-q__row">' + chips + '</div></fieldset>' +
        (ok >= 2 ? '<label class="ppsbs-pick' + (canPick ? '' : ' is-off') + '"><input type="checkbox" name="pick"' + (pickOn ? ' checked' : '') + (!canPick ? ' disabled' : '') + '>' +
          '<span><b>Let my specialist suggest an alternative</b> ' + (canPick ? 'Something they think is worth comparing with your selection.' : 'Remove one of your three to make room for a suggestion.') + '</span></label>' : '') +
        '<label class="ppsbs-field"><span>What would you like your specialist to know?</span><textarea name="note" rows="3" minlength="10" maxlength="600" required placeholder="For example: It\'s a gift for my wife. I love the color of the first one, but I\'m not sure the larger pearls are worth the difference."></textarea>' +
        '<em class="ppsbs-hint">A line or two is plenty. Your specialist reads it before filming and replies with your photos.</em></label>' +
        '<input class="ppsbs-hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<p class="ppsbs-err" data-ppsbs-err hidden></p>' +
        '<button type="submit" class="ppsbs-btn"' + (ok < 1 ? ' disabled' : '') + '>Send photo request</button>' +
        '<p class="ppsbs-fine">' + holdLine(live()) + ' We usually reply within one business day, Monday through Friday.</p>' +
      '</form>';
  }
  function doneHtml(res, preview) {
    var n = WORDS[(res && res.count) || live().length] || '';
    var cnt = (res && res.count) || live().length;
    return '<p class="ppsbs-eyebrow">Photo request</p><h2 class="ppsbs-dlg__h" id="ppsbs-dlg-h">Thank you</h2>' +
      '<div class="ppsbs-done"><b>We have your request.</b> ' +
      (cnt > 1 ? "We'll photograph the " + n + ' pieces together' + (res && res.pick ? ', including one your specialist chooses,' : '') : (res && res.two ? "We'll select " + esc(res.two) + ', photograph them side by side' : "We'll photograph your piece")) +
      ' and email you a link to your private page, usually within one business day.' +
      (cnt === 1 && res && res.two ? ' Choose the one you prefer. ' + esc(res.made || madeOf(null)) : '') +
      (cnt > 1 && res && res.twos ? ' You asked for two options of ' + (res.twos === 1 ? 'one of them' : res.twos + ' of them') + ", so you'll have a choice there too." : '') + '</div>' +
      (preview ? '<p class="ppsbs-preview">Preview build. This request was not sent anywhere.</p>' : '') +
      '<p style="margin:20px 0 0"><button type="button" class="ppsbs-btn" data-ppsbs-close>Close</button></p>';
  }
  // What is held depends on what was chosen: stocked pieces are held 48
  // hours once the photos go out, one-of-a-kind pieces never are.
  function holdLine(list) {
    var one = 0, stock = 0;
    for (var i = 0; i < list.length; i++) { if (list[i].one) one++; else stock++; }
    var base = 'Your selection is available to order from your private page for 48 hours after we send your photos.';
    if (one && !stock) return base + " One-of-a-kind pieces aren't reserved, so one can sell before you decide. If it does, your page will show it as sold.";
    if (stock && !one) return base + ' We hold the pearls we photograph for you during that time.';
    return base + " We hold stocked pearls during that time. One-of-a-kind pieces aren't reserved and can sell sooner.";
  }
  function drawDlg() {
    if (!dlg || dlg._sent) return;
    var body = dlg.querySelector('.ppsbs-dlg__body');
    var keep = {};
    var form = body.querySelector('form');
    if (form) {
      keep.name = form.elements['name'].value; keep.email = form.elements['email'].value; keep.note = form.elements['note'].value;
      var dc = form.querySelector('input[name="deciding"]:checked'); if (dc) dlg._deciding = dc.value;
      var pk = form.elements['pick']; if (pk && !pk.disabled) dlg._pick = pk.checked;
    }
    var d0 = getDraft();
    // Typed in another tab since this panel was drawn: fill what is empty here.
    if (form) {
      if (!keep.name && d0.name) keep.name = d0.name;
      if (!keep.email && d0.email) keep.email = d0.email;
      if (!keep.note && d0.note) keep.note = d0.note;
      if (!dlg._deciding && d0.deciding) dlg._deciding = d0.deciding;
      if (d0.sid && !dlg._sid) dlg._sid = d0.sid;
    }
    if (!form) {
      keep = { name: d0.name || '', email: d0.email || '', note: d0.note || '' };
      if (d0.deciding && !dlg._deciding) dlg._deciding = d0.deciding;
      if (d0.pick != null && dlg._pick == null) dlg._pick = !!d0.pick;
      if (d0.sid && !dlg._sid) dlg._sid = d0.sid;
    }
    body.innerHTML = dlg._mode === 'how' ? howHtml() : reqHtml();
    form = body.querySelector('form');
    if (form) {
      if (keep.name) form.elements['name'].value = keep.name;
      if (keep.email) form.elements['email'].value = keep.email;
      if (keep.note) form.elements['note'].value = keep.note;
      var remember = function () {
        var d = getDraft();
        d.name = form.elements['name'].value; d.email = form.elements['email'].value; d.note = form.elements['note'].value;
        d.deciding = dlg._deciding || ''; d.pick = !!dlg._pick; if (dlg._sid) d.sid = dlg._sid;
        setDraft(d);
      };
      form.addEventListener('input', remember);
      form.addEventListener('change', function () { setTimeout(remember, 0); });
      form.addEventListener('submit', submit);
      form.addEventListener('change', function (e) {
        if (e.target.name === 'deciding') { dlg._deciding = e.target.value; var qq = form.querySelector('.ppsbs-q'); if (qq) qq.classList.remove('is-bad'); }
        if (e.target.name === 'pick') { dlg._pick = e.target.checked; drawDlg(); }
      });
    }
  }

  /* ---------- submit ---------- */
  var busy = false;
  function submit(e) {
    e.preventDefault();
    if (busy) return;
    var f = e.target;
    var err = f.querySelector('[data-ppsbs-err]');
    var name = f.elements['name'].value.trim(), email = f.elements['email'].value.trim(), note = f.elements['note'].value.trim();
    var bad = null;
    var fName = f.elements['name'], fEmail = f.elements['email'];
    var fNote = f.elements['note'];
    var noSize = live().filter(needsSize)[0];
    if (noSize) {
      var ss = f.ownerDocument.querySelector('select[data-ppsbs-size="' + (window.CSS && CSS.escape ? CSS.escape(noSize.h) : noSize.h) + '"]');
      err.textContent = 'Please choose the size you would like us to photograph.';
      err.hidden = false; if (ss) ss.focus(); return;
    }
    if (!name) bad = fName;
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) bad = fEmail;
    else if (note.length < 10) bad = fNote;
    var fields = f.querySelectorAll('.ppsbs-field');
    for (var i = 0; i < fields.length; i++) fields[i].classList.remove('is-bad');
    if (bad) {
      bad.closest('.ppsbs-field').classList.add('is-bad');
      err.textContent = bad === fName ? 'Please add your name.' : bad === fEmail ? 'Please check your email address.' :
        'Please add a short note for your specialist, even a single line.';
      err.hidden = false; bad.focus(); return;
    }
    var picks = live();
    var dc = f.querySelector('input[name="deciding"]:checked');
    var pickBox = f.elements['pick'];
    var wantPick = !!(pickBox && pickBox.checked && !pickBox.disabled);
    if (picks.length >= MAX) wantPick = false;
    if (picks.length < 1) { err.textContent = 'Choose at least one piece that is still available.'; err.hidden = false; return; }
    err.hidden = true;

    // One send, one id: a double-click, a retry, or closing and sending
    // again makes one request. A new id only after a confirmed send.
    var dft = getDraft();
    if (!dlg._sid) dlg._sid = dft.sid || newSid();
    dft.sid = dlg._sid; setDraft(dft);
    var single = picks.length === 1 && !wantPick;
    var two = single && singleTwo(picks) ? twoOf(picks[0]) : '';
    var made = two ? madeOf(picks[0]) : '';
    var twoCount = twos(picks);
    var payload = single ? {
      name: name, email: email, note: note,
      deciding: dc ? dc.value : '',
      specialist_pick: false,
      two: !!two, // TWO. YOUR CHOICE. (Oct 11 2026): the Worker sets up A and B, same spec
      variant_id: picks[0].v,
      from: 'tray',
      sid: dlg._sid,
      url: window.location.origin + window.location.pathname,
      hp: f.elements['website'].value,
      ms: Date.now() - shownAt
    } : {
      kind: 'side_by_side',
      sid: dlg._sid,
      name: name, email: email, note: note,
      deciding: dc ? dc.value : '',
      specialist_pick: wantPick,
      items: picks.map(function (x) { return { variant_id: x.v, product_id: x.pid, handle: x.h, two: wantsTwo(x) }; }),
      variant_id: picks[0].v,
      url: window.location.origin + window.location.pathname,
      hp: f.elements['website'].value,
      ms: Date.now() - shownAt
    };

    if (!CFG.live || !CFG.endpoint || !window.fetch) {
      if (window.console) console.info('[pp-sbs] preview, not sent', payload);
      finish({ count: picks.length + (wantPick ? 1 : 0), pick: wantPick, two: two, made: made, twos: twoCount }, true);
      return;
    }
    busy = true;
    var btn = f.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = 'Sending';
    // Up to 30 seconds, and one quiet retry if the connection drops. The same
    // id goes with both tries, so a retry never makes a second request.
    var send = function (tries) {
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 30000);
      return fetch(CFG.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        clearTimeout(timer);
        return r.json().catch(function () { return null; }).then(function (j) { return j || { ok: false, error: 'http_' + r.status }; });
      }, function (e) {
        clearTimeout(timer);
        var why = e && e.name === 'AbortError' ? 'timeout' : 'network';
        if (why === 'network' && tries < 1) return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return send(tries + 1); });
        return { ok: false, error: why };
      });
    };
    send(0).then(function (res) {
        busy = false;
        if (res && res.error === 'sold' && res.sold && res.sold.length) {
          // A piece sold while they were choosing. Mark it and let them
          // send the rest, or pick another.
          res.sold.forEach(function (h) { soldMap[h] = true; });
          render();
          var e2 = dlg.querySelector('[data-ppsbs-err]');
          if (e2) { e2.textContent = 'One of these pieces has just sold. Remove it, or add another, and send again.'; e2.hidden = false; }
          return;
        }
        if (!res || !res.ok) {
          var why = (res && res.error) || 'unknown';
          btn.disabled = false; btn.textContent = 'Send photo request';
          err.textContent = why === 'network' ? "We couldn't reach our server. Please check your connection and press Send again. Your details are saved." :
            why === 'timeout' ? "This is taking longer than usual. Please press Send again in a moment. You won't get a duplicate request." :
            why === 'email' ? 'Please check your email address.' :
            "Something went wrong on our side. Please press Send again, or email us and we'll set it up for you. Your details are saved.";
          err.hidden = false;
          keepForm();
          try { if (window.gtag) window.gtag('event', 'photo_request_error', { reason: String(why).slice(0, 40), piece_count: picks.length }); } catch (e) {}
          if (window.console) console.warn('[pp-sbs] send failed', why);
          return;
        }
        res.count = picks.length + (wantPick ? 1 : 0);
        res.pick = wantPick; res.two = two; res.made = made; res.twos = twoCount;
        dlg._sid = '';
        clearDraft();
                if (res.request_number) { try { if (window.gtag) window.gtag('event', res.count > 1 ? 'side_by_side_request' : 'photo_request', { request_number: res.request_number, piece_count: res.count, deciding: dc ? dc.value : '', specialist_pick: wantPick }); if (window.gtag) window.gtag('event', 'conversion', { send_to: res.count > 1 ? 'AW-1070316182/jrFRCIjAoYwdEJb1rv4D' : 'AW-1070316182/dceICJ7EoYwdEJb1rv4D' }); } catch (e) {} }
        clearAll();
        finish(res, false);
        render();
      });
  }
  function finish(res, preview) {
    dlg._sent = true;
    dlg.querySelector('.ppsbs-dlg__body').innerHTML = doneHtml(res, preview);
    var c = dlg.querySelector('.ppsbs-dlg__body [data-ppsbs-close]');
    if (c) c.focus();
  }

  /* ---------- sold checks ---------- */
  var checked = {};
  function checkSold() {
    items.forEach(function (it) {
      if (checked[it.h]) return;
      checked[it.h] = true;
      if (!window.fetch) return;
      fetch(ROOT + 'products/' + encodeURIComponent(it.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.status === 404 ? { available: false } : (r.ok ? r.json() : null); })
        .then(function (p) {
          if (!p) return;
          var was = soldMap[it.h];
          soldMap[it.h] = p.available === false;
          if (was !== soldMap[it.h]) render();
        }).catch(function () {});
    });
  }

  document.addEventListener('change', function (e) {
    var sz = e.target && e.target.closest ? e.target.closest('select[data-ppsbs-size]') : null;
    if (!sz || sz.value === '') return;
    var si = idx(sz.getAttribute('data-ppsbs-size'));
    if (si === -1) return;
    pickSize(items[si], +sz.value);
    save(); render();
  });

  /* ---------- shared clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var rm = t.closest('[data-ppsbs-rm]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-ppsbs-rm')); render(); return; }
    var tw = t.closest('input[data-ppsbs-two]');
    if (tw) { var ti = idx(tw.getAttribute('data-ppsbs-two')); if (ti !== -1) { items[ti].twoOn = tw.checked; save(); render(); } return; }
    if (t.closest('[data-ppsbs-clear]')) { clearAll(); clearDraft(); if (dlg) { dlg._sid = ''; dlg._deciding = ''; dlg._pick = null; var ff = dlg.querySelector('.ppsbs-dlg__body form'); if (ff) ff.reset(); } render(); return; }
    if (t.closest('[data-ppsbs-find]')) { goFind(); return; }
    if (t.closest('[data-ppsbs-addhere]')) {
      var pr = pdpRoot();
      if (pr && add(pdpItem()) === 'ok') { pr._folded = false; render(); checkSold(); }
      return;
    }
    if (t.closest('[data-ppsbs-more]')) { closeDlg(); return; }
    var op = t.closest('[data-ppsbs-open]');
    if (op && !op.disabled) { openDlg('req', op); return; }
    var how = t.closest('[data-ppsbs-how]');
    if (how) { openDlg('how', how); return; }
    if (t.closest('[data-ppsbs-close]')) { closeDlg(); return; }
  });

  /* ---------- render ---------- */
  function render() {
    syncChecks();
    renderTray();
    renderPdp();
    renderLower();
    if (dlg && !dlg.hidden && dlg._mode === 'req') drawDlg();
  }
  function refresh() { items = load(); render(); checkSold(); }

  function init() {
    items = load();
    explainer();
    render();
    watchVariant();
    checkSold();
  }
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refresh();
    // Sent or cleared in another tab: this tab's form starts fresh too.
    if (e.key === DRAFT && !e.newValue && dlg && !dlg._sent) {
      dlg._sid = ''; dlg._deciding = ''; dlg._pick = null;
      var ff = dlg.querySelector('.ppsbs-dlg__body form'); if (ff) ff.reset();
      if (!dlg.hidden) drawDlg();
    }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.ppSbs = { items: function () { return items.slice(); }, clear: function () { clearAll(); render(); } };
})();
